import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { userCanEdit } from './user_helpers';

const buildMapMenuItems = (
  context,
  data,
  openDownloadModal,
  isRefreshed,
  refreshMap,
  isHidden,
  updateHidden,
  handleDeleteClick,
  addAsNewMap,
  isMapOwner,
  saveMapAsClone
) => {
  const canEdit = userCanEdit(context, data?.user);
  const menuItems = [];

  menuItems.push({ label: StringConstantsMixin.strings.MAP_CREATOR.DOWNLOAD_MAP, callback: openDownloadModal });

  if (context.adminUser) {
    menuItems.push(
      {
        label: isRefreshed ? StringConstantsMixin.strings.MAP_CREATOR.REFRESHED : StringConstantsMixin.strings.MAP_CREATOR.REFRESH,
        callback: refreshMap
      },
      {
        label: isHidden ? StringConstantsMixin.strings.TRACK_DETAIL.UNHIDE : StringConstantsMixin.strings.TRACK_DETAIL.HIDE,
        callback: updateHidden
      }
    );
  }

  if (canEdit && data.id) {
    menuItems.push({
      label: StringConstantsMixin.strings.MAP_CREATOR.DELETE_MAP,
      callback: handleDeleteClick
    });
  }

  if (context.currentUser && !data.private && !context.mobileBrowser) {
    menuItems.push({
      label: context.adminUser
        ? StringConstantsMixin.strings.MAP_CREATOR.ADD_AS_NEW_TRAIL
        : StringConstantsMixin.strings.MAP_CREATOR.SUGGEST_AS_NEW_TRAIL,
      callback: addAsNewMap
    });
  }

  if (!isMapOwner && data.name && data.id) {
    menuItems.push({
      label: StringConstantsMixin.strings.CUSTOMIZE_MAP,
      callback: saveMapAsClone
    });
  }

  return menuItems;
};

const buildTrackMenuItems = (
  context,
  data,
  openDownloadModal,
  isEditingEndpoint,
  handleEditEndpointClick,
  handleCancelEditEndpointClick,
  handleEditClick,
  isRefreshed,
  refreshMap,
  handleDeleteClick,
  saveMapAsClone
) => {
  const menuItems = [];
  const trackDetail = StringConstantsMixin.strings.TRACK_DETAIL;
  const canEdit = userCanEdit(context, data?.user, true);
  const gpxLinkText = data?.routes && data.routes.length > 1 ? trackDetail.DOWNLOAD_ROUTES : trackDetail.DOWNLOAD_ROUTE;

  menuItems.push({
    label: gpxLinkText,
    callback: openDownloadModal
  });

  if (canEdit) {
    menuItems.push({
      label: isEditingEndpoint ? StringConstantsMixin.strings.TRACK_DETAIL.SAVE_ENDPOINT : StringConstantsMixin.strings.TRACK_DETAIL.EDIT_ENDPOINT,
      callback: handleEditEndpointClick
    });

    if (isEditingEndpoint) {
      menuItems.push({
        label: StringConstantsMixin.strings.CANCEL_EDIT,
        callback: handleCancelEditEndpointClick
      });
    }
  }

  if (canEdit && data.id) {
    menuItems.push({
      label: StringConstantsMixin.strings.EDIT,
      callback: handleEditClick
    });
  }

  if (context.adminUser) {
    menuItems.push({
      label: isRefreshed ? StringConstantsMixin.strings.MAP_CREATOR.REFRESHED : StringConstantsMixin.strings.MAP_CREATOR.REFRESH,
      callback: refreshMap
    });
  }

  if (context.currentUser && data.id) {
    menuItems.push({
      label: StringConstantsMixin.strings.CUSTOMIZE_MAP,
      callback: saveMapAsClone
    });
  }

  if (canEdit && data.id) {
    menuItems.push({
      label: StringConstantsMixin.strings.DELETE,
      callback: handleDeleteClick
    });
  }
  return menuItems;
};

export { buildMapMenuItems, buildTrackMenuItems };
